<div class="summary-info">
  <div class="summary-header">
    <h2>{{ 'Summary information' | translate }}</h2>
     
  </div>

  <app-problematic-areas *ngIf="!isAdmin"></app-problematic-areas>
</div>